import type React from "react";

import { cn } from "~/lib/utils";

interface PlpBottomBannerProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown> & { className?: string };
}

export function PlpBottomBanner({
  children,
  attributes,
}: PlpBottomBannerProps) {
  const { className, ...restAttributes } = attributes ?? {};
  return (
    <div className={cn("w-full", className)} {...restAttributes}>
      {children}
    </div>
  );
}
